import { clinicId, websocketServiceUrl } from "../constants";
// import { getDiagnosisDetails } from "../Insurance/ProcessedClaims/services";
import { getItem, storageKey } from "../utilis/methods/storage/storage";
// import { getAllBackUp, sqlBackUp } from "../Settings/BackUp/service";
// import { Save } from "@mui/icons-material";

// const tokenData = getItem(storageKey.TOKEN);
// const userDetails = getItem("user_data");
// const gruopName = localStorage.getItem(storageKey.groupName) || "GUST"
// const user = gruopName.toLowerCase();

const services = {
  master: "/master-service/api",
  default: "/clinic-service",
  services: "/clinic-service",
  websocket: websocketServiceUrl,
};
export const access_token = getItem(storageKey.accessToken);
const user = "admin";

const authentication = {
  login: `${services.master}/login/verify`,
  logout: `${services.default}/logout/verify`,
  tokenVerify: `${services.master}/auth/token`,
  getPrivilage: `${services.master}/v1/privileges`,
};

// const patientBooking = {
//   getAllDepartment: `${services.default}/booking/department`,
// }

const walletapi = {
  getPatientsList: `${services.default}/emrlanding/getBySearch`,
  getPatientsListExcel: `${services.default}/emrlanding/getBySearchExcel`,
  getWalletAmount: `${services.default}/wallet/checkPatientId/`,
  saveWallet: `${services.default}/wallet/savePayment`,
  ModeOfPayment: `${services.default}/wallet/modeOfPayment`,
  printReceipt: `${services.default}/wallet/generateReport/`,
  walletStatement: `${services.default}/wallet/generateStatement`,
};

const patientRegistrationApi = {
  maritalStatus: `${services.default}/registration/maritalstatus/${clinicId}`,
  languageApi: `${services.default}/registration/language/${clinicId}`,
  raceApi: `${services.default}/registration/race/${clinicId}`,
  addressTypeApi: `${services.default}/registration/address/${clinicId}`,
  countryApi: `${services.default}/registration/nationality/${clinicId}`,
  stateApi: `${services.default}/registration/states/`,
  postOfficeApi: `${services.default}/rcm/${user}/postoffice/getpo/?access_token=${access_token}&clinicId=${clinicId}`,
  religonApi: `${services.default}/registration/religion/${clinicId}`,
  saveApi: `${services.default}/registration/save`,
  getBookingDetails: `${services.default}/rcm/${user}/doctorbooking/getbypatientmasterid/`,
  getPatientByemr: `${services.default}/registration/getpatientbyemr`,
  getPatientById: `${services.default}/registration/getpatient`,
  getByPatientMasterId: `${services.default}/registration/getpatientbymasterid`,
  getContactTypes: `${services.default}/registration/contactrole/`,
  getRelations: `${services.default}/registration/specificrelation/`,
  save: `${services.default}/registration/save`,
  getUploadedDocuments: `${services.default}/registration/get-documents/`,
  allDocumentsByPatientMasterId: `${services.default}/registration/all-documents/`,
  deleteUploadedDocument: `${services.default}/registration/delete-document/`,
};

const patientBookingApi = {
  getAllBookings: `${services.default}/calender/bookinglist`,
  getAllDepartments: `${services.default}/booking/department/`,
  getAllDoctorsBooking: `${services.default}/booking/v2/getalldoctorsbooking`,
  getDoctorByDepartment: `${services.default}/booking/getdocbydepartment`,
  getTimeSlot: `${services.default}/booking/department/timeslot`,
  getAllTimeSlot: `${services.default}/booking/department/alltimeslot`,
  saveBooking: `${services.default}/calender/booking`,
  saveBookingv2: `${services.default}/calender/v2/booking`,
  alldoctors: `${services.default}/booking/doctor/`,
  changeSlot: `${services.default}/calender/datechange`,
  deleteBooking: `${services.default}/calender/booking/`,
  slotCompleteDeleteBooking: `${services.default}/calender/v2/booking`,
  visitType: `${services.default}/encounter/visittype/`,
  doctorsWaitingList: `${services.default}/calender/doctors-waiting-list/`,
  getBookingWithReviewDate: `${services.default}/booking/getbookingwithreviewdate`,
};

const cashierApi = {
  getbilledPatients: `${services.default}/cashier/getbilledpatients`,
  getbilledPatientsv2: `${services.default}/cashier/getbilledpatientspartial`,
  getCashierbilldetails: `${services.default}/cashier/v1/paidlist`,
  getCashierbilldetailsforpartial: `${services.default}/cashier/paidlist`,
  getbilledItemdetails: `${services.default}/cashier/getbilleditemdetails`,
  getbilledItemdetailsPartialPay: `${services.default}/cashier/getbilleditemdetailspartialpayinternalcodes`,
  patientientPaymentDetails: `${services.default}/cashier/patientpaymentdetails`,
  AddPayment: `${services.default}/cashier/createpayment`,
  AddPaymentPartialPay: `${services.default}/cashier/createpaymentpartialpay`,
  getLedgerData: `${services.default}/cashier/getpatientledger`,
  getPatientLedgerData: `${services.default}/cashier/ledger`,
  getPrint: `${services.default}/cashier/getcashierreport`,
  getPrintv2New: `${services.default}/cashier/generaterecipt`,
  delete: `${services.default}/cashier/cancelpayment`,
  deleteV2: `${services.default}/cashier/cancelPaymentpartial`,
};

const receptionApi = {
  patientDetails: `${services.default}/rcm/${user}/doctorbooking/getbypatientmasterid/`,
  getAppointments: `${services.default}/reception/searchReceptionAppointment`,
  getEncounter: `${services.default}/reception/searchReceptionEncounter`,
  getallDoctor: `${services.default}/reception/getalldoctor`,
  getPatientByencounterId: `${services.default}/emrlanding/getEncounterById`,
  cancelEncounter: `${services.default}/reception/cancelencounteredpatient`,
};

const nursingApi = {
  getProcedureList: `${services.default}/emrlanding/getbynurseproceduresearch`,
  getProcedure: `${services.default}/emrlanding/getNurseProcedureById/`,
  updateNursing: `${services.default}/emrlanding/update-nurse-procedure`,
  getAllBloodGroup: `${services.default}/emr/getallbloodgroup`,
  getvitalsById: `${services.default}/emr/getvitalsbyid/`,
  saveVitals: `${services.default}/emr/postVitalSigns`,
  getAllTriage: `${services.default}/emr/gettraige`,
  saveTriage: `${services.default}/emr/traigesave`,
};

const patientEncounterApi = {
  getAllDepartmentApi: `${services.default}/rcm/${user}/department/getDept?access_token=${access_token}&clinicId=${clinicId}`,
  getDoctorApi: `${services.default}/rcm/${user}/getbydept/`,
  getPurpose: `${services.default}/encounter/visitpurpose/`,
  getAllClinicianApi: `${services.default}/rcm/${user}/patientreg/getAllClinicians?access_token=${access_token}&clinicId=${clinicId}`,
  getInsuranceType: `${services.default}/rcm/${user}/claimListing/getAllInsuranceTypes?access_token=${access_token}&clinicId=${clinicId}`,
  getTPAorInsuranceByType: `${services.default}/rcm/${user}/claimListing/getInsByType?access_token=${access_token}&clinicId=${clinicId}`,
  getInsurancePlan: `${services.default}/rcm/${user}/insurancePlan/getAllInsPlanByInsDetails?access_token=${access_token}&clinicId=${clinicId}`,
  getAllPatients: `${services.default}/rcm/${user}/patientreg/getAllPatients?access_token=${access_token}&clinicId=${clinicId}`,
  getPatientByEmr: `${services.default}/rcm/${user}/patientreg/getPatientByEmr?access_token=${access_token}&clinicId=${clinicId}`,
  getCptGroups: `${services.default}/rcm/${user}/patientreg/getCptGroups?access_token=${access_token}&clinicId=${clinicId}`,
  saveOrUpdateEncounter: `${services.default}/rcm/${user}/patientregistration/saveOrUpdateEncounter?access_token=${access_token}&clinicId=${clinicId}`,
  postOfficeApi: `${services.default}/encounter/getpostOffices/`,
  getallinsType: `${services.default}/encounter/getallinsurancetypes/`,
  getInsByTpe: `${services.default}/encounter/getInsByType`,
  getInsPlan: `${services.default}/encounter/insplanbyinsdetails`,
  getAllclinician: `${services.default}/encounter/getclinicians/`,
  getAllPatient: `${services.default}/encounter/search`,
  getEncounterDetailsByEmr: `${services.default}/patient/encounter-details`,
  getBillingHistoryByEncounterId: `${services.default}/patient/billing-history`,
  getBillingHistoryByEncounterIdInternalCodes: `${services.default}/patient/billing-history-internalcodes`,
  getcptgroups: `${services.default}/encounter/getcptgroups/`,
  saveEncounter: `${services.default}/encounter/save`,
};

const insuranceApi = {
  getInsuranceType: `${services.default}/rcm/${user}/claimListing/getAllInsuranceTypes?access_token=${access_token}&clinicId=${clinicId}`,
  getTPAorInsuranceByType: `${services.default}/rcm/${user}/claimListing/getInsByType?access_token=${access_token}&clinicId=${clinicId}`,
  getInsurancePlan: `${services.default}/rcm/${user}/insurancePlan/getAllInsPlanByInsDetails?access_token=${access_token}&clinicId=${clinicId}`,
  getPatientByencounterId: `${services.default}/rcm/${user}/patientreg/getpatientByEncounterId`,
  getProblems: `${services.default}/rcm/${user}/problems/find?access_token=${access_token}&clinicId=${clinicId}`,
  getVitals: `${services.default}/emr/getVitalSigns/`,
  listPriorActivities: `${services.default}/rcm/${user}/priorapproval/listPriorActivities/`,
  listPriorDiagnosis: `${services.default}/rcm/${user}/priorapproval/listPriorDiagnosis/`,
  listPriorObserv: `${services.default}/rcm/${user}/priorapproval/listPriorObserv/`,
  priorApprovalsPatientSearch: `${services.default}/priorapproval/getpatients`,
  claimListTableData: `${services.default}/claim/getInsPatientDetails`,
  listPriorApprovals: `${services.default}/priorApproval/findPriorApprovals`,
  downloadPriorApproval: `${services.default}/priorapproval/downloadpriorapproval/`,
  searchPriorApproval: `${services.default}/priorapproval/searchpriorapproval`,
  findPriorApprovals: `${services.default}/priorapproval/findpriorapprovals`,
  claimSubmission: `${services.default}/claim/submission`,
  claimDownload: `${services.default}/claim/downloadclaim`,
  getAllStatus: `${services.default}/verification/getAllStatus`,
  verificationList: `${services.default}/claim/getVerificationList`,
  updateClaimStatus: `${services.default}/rcm/${user}/claimProcess/updateClaimStatus?access_token=${access_token}&clinicId=${clinicId}`,
  getDiagnosisData: "",
  downloadRemitance: `${services.default}/remittance/download`,
  searchRemittanceWithDate: `${services.default}/remittance/search`,
  getRemittanceActivity: `${services.default}/remittance/getActivity/`,
  getcptDetails: `${services.default}/cptDetails/`,
  getComplaints: `${services.default}/complaints/getcomplaints/`,
  getRadiology: `${services.default}/rcm/${user}/emr/findRadiology?access_token=${access_token}`,
  getActivity: `${services.default}/activity/getallactivities/`,
  updateStatusOfClaim: `${services.default}/verification/update`,
  auditLog: `${services.default}/logs/auditlogs/`,
  uploadFile: `${services.default}/uploaddocuments/resultupload`,
  getUploadedDocument: `${services.default}/uploaddocuments/getDocument`,
  getAllDocuments: `${services.default}/uploaddocuments/getalldocuments`,
  deleteDocument: `${services.default}/uploaddocuments/deletedocument`,
};

const emr = {
  hl7Trigger: `${services.default}/hl7/triggerevent`,
  activitySearch: `${services.default}/investigation/findcpt`,
  activitySearchv2: `${services.default}/investigation/findcptinternalcodes`,
  addCptFavourite: `${services.default}/investigation/addcptfavorite`,
  activitySave: `${services.default}/investigation/saveactivity`,
  deleteActivity: `${services.default}/investigation/deleteactivity`,
  getIcdCodes: `${services.default}/icd/icdautoinput/`,
  postDiagnosis: `${services.default}/diagnosis/postdiagnosis`,
  getEmrDiagnosis: `${services.default}/diagnosis/`,
  getcptDeails: `${services.default}/activity/getallactivities/`,
  deleteDiagnosis: `${services.default}/diagnosis/deletediagnosis/`,
  // medical history
  postSecondMedicalHistory: `${services.default}/medicalhistory/MedicalDetails`,
  getSecondMedicalHistory: `${services.default}/medicalhistory/MedicalDetails/`,
  getAllDisease: `${services.default}/icd/icdautoinput/`,
  postMedicalHistoryDisease: `${services.default}/medicalhistory/disease`,
  postMedicalHistory: `${services.default}/medicalhistory/add`,
  getMedicalHistory: `${services.default}/medicalhistory/find/`,
  deleteMedicalHistory: `${services.default}/medicalhistory/delete/`,
  getHistoryDetailsRevisionLog: `${services.default}/rcm/${user}/medicalHistory/details/getHistoryDetailsRevisionLog/`,
  // getFamilyHistory
  PostFamilyHistory: `${services.default}/familyhistory`,
  revisionLog: `${services.default}/logs/`,
  getfamilyHistoryIcd: `${services.default}/emr/alldiseasebyname/`,
  getFamilyHistory: `${services.default}/familyhistory`,
  getPatientRelation: `${services.default}/familyhistory/patientrelation/`,
  deletFamilyHistory: `${services.default}/familyhistory/delete`,
  // allergy tab
  getAllergyType: `${services.default}/allergy/getallergytype/`,
  getAllergySeverity: `${services.default}/allergy/getallergyseverity/`,
  getAllergen: `${services.default}/allergy/allergen/`,
  getAllergyStatus: `${services.default}/allergy/getlifecyclestatus/`,
  getAllergy: `${services.default}/allergy/`,
  postAllergy: `${services.default}/allergy/saveallergy`,
  deleteAllergy: `${services.default}/allergy/deleteallergy/`,
  allergyCount: `${services.default}/rcm/${user}/allergy/getallergyList/`,
  // socialH History
  postSocialHistory: `${services.default}/socialHistory/postSocialHistory`,
  getSocialHistory: `${services.default}/socialHistory/getSocialHistory/`,
  getSocialHabitCategory: `${services.default}/emr/socialhabitcategory/`,
  getLifeCycleStatus: `${services.default}/emr/getlifeCycleStatus`,
  getSocialHabitDescription: `${services.default}/emr/getDescription/`,
  getSocialQuantity: `${services.default}/emr/getSocialQuantity/`,
  deleteSocialHistory: `${services.default}/socialHistory/deleteSocialHistory/`,
  // problems
  getProblemsList: `${services.default}/problem/getproblems/`,
  postProblems: `${services.default}/problem/saveProblems`,
  problemsByDiagnosis: `${services.default}/emr/geticdsnomed/`,
  getDiagnosis: `${services.default}/emr/diag/`,
  deleteProblems: `${services.default}/problem/deleteProblems/123`,
  // prescription tab
  saveprescription: `${services.default}/prescription/saveprescription`,
  getPrescription: `${services.default}/prescription/getprescription/`,
  getDrugs: `${services.default}/prescription/getdrugs/`,
  addPrescriptionFavourite: `${services.default}/prescription/addprescriptionfavorite`,
  getUnit: `${services.default}/prescription/getprescriptionunits/`,
  getFrequency: `${services.default}/prescription/getfrequency/`,
  getDosageTiming: `${services.default}/prescription/getdosagetimings/`,
  getRouteOfAdmin: `${services.default}/prescription/getrouteofadmin/`,
  deletePrescription: `${services.default}/prescription/deleteprescription/`,
  submitErx: `${services.default}/prescription/erx/upload/`,
  prescriptionPrint: `${services.default}/prescription/print/`,
  prescritionClaimForm: `${services.default}/claimform/`,
  // complaints tab
  getComplaints: `${services.default}/complaints/getcomplaints/`,
  getComplaintsMaster: `${services.default}/complaints/getcomplaintsmaster/`,
  getHpi: `${services.default}/complaints/gethpi/`,
  saveComplaints: `${services.default}/complaints/postcomplaint`,
  getConsultationDetails: `${services.default}/emrlanding/getconsultationdetails/`,
  updateConsultation: `${services.default}/billing/updateConsultation`,
  getConsultationCode: `${services.default}/emrlanding/getcptautoinput`,
  deleteComplaints: `${services.default}/complaints/deletecomplaints/`,
  // investigation radiology and lab
  getLabDropdown: `${services.default}/rcm/${user}/cpt/getLabCptAutoInput?access_token=${access_token}`,
  getRadiologyDropdown: `${services.default}/rcm/${user}/cpt/getRadiologyCptAutoInput?access_token=${access_token}`,
  checkCptRate: `${services.default}/rcm/${user}/rate/getRateTest?access_token=${access_token}`,
  getCptRate: `${services.default}/rcm/${user}/cpt/editcpt/`,
  postRadiology: `${services.default}/rcm/${user}/emr/postRadiology?access_token=${access_token}`,
  postLab: `${services.default}/rcm/${user}/emr/postLab?access_token=${access_token}`,
  getLab: `${services.default}/investigation/findLab`,
  getRadiology: `${services.default}/investigation/findRadiology`,
  deleteRadiology: `${services.default}/rcm/${user}/emr/deleteRadiology?access_token=${access_token}`,
  deleteLab: `${services.default}/rcm/${user}/emr/deleteLab?access_token=${access_token}`,
  getPatientShare: `${services.default}/investigation/patshare`,
  // procedures tab
  getProcedureCpCode: `${services.default}/rcm/${user}/cpt/getProcedureDugsByPOAutoInput?access_token=${access_token}`,
  getProcedureRate: `${services.default}/rcm/${user}/cpt/editcpt/`,
  getProcedures: `${services.default}/investigation/findprocedures`,
  postProcedure: `${services.default}/rcm/${user}/procedure/saveProcedure?access_token=${access_token}`,
  deleteProcedures: `${services.default}/rcm/${user}/procedure/proDelete?access_token=${access_token}`,
  deleteProcedure: `${services.default}/rcm/${user}/medicalHistory/disease/delete?access_token=${access_token}`,
  // physical examination
  getRosFields: `${services.default}/rcm/${user}/ros/getAllBodySystems?access_token=${access_token}`,
  getPhysicalExamination: `${services.default}/physicalexamination/getphysicalexamination/`,
  getRosFieldList: `${services.default}/physicalexamination/physicalexams/`,
  deleteFirstPhysicalExamination: `${services.default}/physicalexamination/deletephysicalexamination/`,
  postPhysicalExamination: `${services.default}/physicalexamination/savephysicalexamination`,
  postSecondPhysicalExamination: `${services.default}/physicalexamination/add`,
  emrList: `${services.default}/emrlanding/psearch`,
  emrListv2: `${services.default}/emrlanding/v2/psearch`,
  getBodySystemList: `${services.default}/ros/getallbodysystems/`,
  getRosBs: `${services.default}/ros/getRosBs/`,
  removePhysicalExamination: `${services.default}/physicalexamination/delete/`,
  // management plan tab
  getManagementPlan: `${services.default}/management/managementplan/`,
  getTreatmentPlan: `${services.default}/management/treatmentplan/`,
  getClinicalImpression: `${services.default}/management/clinicalimpression/`,
  postManagementPlan: `${services.default}/management/managementplan`,
  postTreatmantPlan: `${services.default}/management/treatmentplan`,
  postClinicalImpression: `${services.default}/management/clinicalimpression`,
  // submit emr
  submitEmr: `${services.default}/emrlanding/submitemr`,
  sendTreatmentEstimate: `${services.default}/emr/treatment-estimate/`,
  telemedicine: `${services.default}/telemedicine`,
  journeyOfPatient: `${services.default}/bookingjourney/journeyofpatient`,
  journeyOfEncounter: `${services.default}/bookingjourney/journeyofencounter`,
  journeyOfEncounters: `${services.default}/bookingjourney/journeyofencounters`,
  consultationStart: `${services.default}/bookingjourney/consultationstart`,
  updateReview: `${services.default}/encounter/updatereview`,
  checkDiagnosis: `${services.default}/rcm/${user}/diagnosis/checkDiag/`,
  userLogHistory: `${services.default}/rcm/${user}/userLogHistory?access_token=${access_token}`,
  updateRegistration: `${services.default}/rcm/${user}/patientreg/updateRegistrationStatus?access_token=${access_token}`,
  // prior approval
  getPriorApproval: `${services.default}/rcm/${user}/encounter/getPriorRequestItems/`,
  submitPriorApproval: `${services.default}/priorapproval/submitpriorapproval`,
  // view vitals
  viewVitas: `${services.default}/emr/getVitalSigns/`,
  // view details
  viewdetails: `${services.default}/emrlanding/getallencountersofpatientid`,
  getViewLabDetails: `${services.default}/emrlanding/getlabdetails/`,
  getViewRadiologyDetails: `${services.default}/emrlanding/getradiodetails/`,
  getAllUploadedDocuments: `${services.default}/emrlanding/getalldocuments`,
  getViewUploadedFile: `${services.default}/emrlanding/getdocpreview`,
  getDischargeHistorySummary: `${services.default}/consentforms/dischargehistorysummary`,
  getDischargeHistorySummaryv2: `${services.default}/consentforms/dischargehistorysummaryinternalcodes`,

  // activity tab
  postActiviy: `${services.default}/activityimage/save`,
  activityList: `${services.default}/activityimage/find`,
  viewActivityFile: `${services.default}/activityimage/viewfullbodyfile`,
  // upload documents
  getDocumentTypes: `${services.default}/uploaddocuments/getdocumenttype/`,
  saveDocument: `${services.default}/uploaddocuments/save`,
  getUploadedDocumentList: `${services.default}/uploaddocuments/get/`,
  deleteDocument: `${services.default}/uploaddocuments/delete/`,
  // Dental Tab
  saveDental: `${services.default}/dental/save`,
  getDentalCpt: `${services.default}/investigation/findcpt`,
  getDentalList: `${services.default}/dental/find/`,
  getDentalListV2: `${services.default}/dental/findinternalcodes`,
  deleteDental: `${services.default}/dental/delete/`,
  getInsRate: `${services.default}/rate`,
  getInsurancePatientShare: `${services.default}/investigation/patshare`,
  // consentForms
  procedureForm: `${services.default}/consentforms/procedureform/`,
  generalConSentForm: `${services.default}/consentforms/generalconsentform/`,
  medicalConsentFrom: `${services.default}/consentforms/medicalconsentform/`,
  Attendence: `${services.default}/consentforms/Attendance/`,
  dischargeSummary: `${services.default}/consentforms/dischargesummary/`,
  dischargeSummaryv2: `${services.default}/consentforms/dischargesummaryinternalcodes`,
  sickLeave: `${services.default}/consentforms/sickleave`,
  fitFor: `${services.default}/consentforms/fitforcertificate`,
  caseInjuary: `${services.default}/consentforms/caseinjury`,
  AttendedLeaveCertificate: `${services.default}/consentforms/attendantleave`,
  referalLetter: `${services.default}/consentforms/referralletter`,
  consentFormsMaster: `${services.default}/consentforms/uploadfile`,
  consentFormMasterSave: `${services.default}/formtemplate/save`,
  getConsentForm: `${services.default}/formtemplate/gettemplete/`,
  getAllConsentFormList: `${services.default}/formtemplate/fetchformnamebyclinicid`,

};

const reportsApi = {
  insuranceWiseOutStanding: `${services.default}/reports/insurancewisereport`,
  insuranceWiseOutStandingSearch: `${services.default}/reports/getinsurancedata`,
  dailyRevenueReport: `${services.default}/reports/dailyrevenuereportsearchv1`,
  dailyRevenueReportPdf: `${services.default}/reports/dailyrevenuereportpdf`,
  dailyRevenueReportExcel: `${services.default}/reports/dailyrevenuereportsearchexcel`,
  patientlistReportSearch: `${services.default}/reports/patientlistreportsearch`,
  patientlistReportSearchpdf: `${services.default}/reports/patientlistreportsearchpdf`,
  patientlistReportSearchexcel: `${services.default}/reports/patientlistreportsearchexcel`,
  appointmentReportSearch: `${services.default}/reports/appointmentlistreportsearch`,
  appointmentReportSearchpdf: `${services.default}/reports/appointmentlistreportsearchpdf`,
  appointmentListReportServiceDepartmentwiseFilteringpdf: `${services.default}/reports/departmentwiseappointmentlistreportsearchpdf`,
  appointmentListReportServiceDepartmentwiseFilteringExcel: `${services.default}/reports/departmentwiseappointmentlistreportsearchexcel`,
  appointmentReportSearchexcel: `${services.default}/reports/appointmentlistreportsearchexcel`,
  encounterListReportSearch: `${services.default}/reports/encounterlistreportsearch`,
  encounterListReportSearchpdf: `${services.default}/reports/encounterlistreportsearchpdf`,
  encounterListReportSearchexcel: `${services.default}/reports/encounterlistreportsearchexcel`,
  billwiseReportSearch: `${services.default}/reports/billwisereportsearch`,
  billwiseReportSearchInternalCode: `${services.default}/reports/billwisereportsearchInternalCode`,
  billWiseReport: `${services.default}/reports/billwisereportsearchpdf`,
  patientwiseReportSearch: `${services.default}/reports/patientwisereportsearch`,
  patientwiseReport: `${services.default}/reports/patientwisereportsearchexcel`,
  agingReportPdf: `${services.default}/reports/ageingreport`,
  agingReportTableDataOld: `${services.default}/reports/getagingdata`,
  agingReportTableData: `${services.default}/reports/getagingdata`,
  patientlistReport: `${services.default}/reports/patientlistreport`,
  dailyInvoiveReport: `${services.default}/reports/getdailyinvoiocedetail`,
  dailyInvoiveReportPdf: `${services.default}/reports/getdailyinvoicereport`,
  codificationStatusreport: `${services.default}/reports/codificationstatusreportsearch`,
  codificationStatusreportpdf: `${services.default}/reports/codificationstatusreportsearchpdf`,
  codificationStatusreportexcel: `${services.default}/reports/codificationstatusreportsearchexcel`,
  monthlyInvoiveReport: `${services.default}/reports/monthlyinvoicereportsearch`,
  monthlyInvoiveReportPdf: `${services.default}/reports/monthlyinvoicereportsearchpdf`,
  doctorWiseBillingReport: `${services.default}/reports/getdoctorwisecollectiondetails`,
  doctorWiseBillingReportPdf: `${services.default}/reports/getdoctorwisecollectionreport`,
  encounterWiseCollection: `${services.default}/reports/encounterwisereportsearch`,
  encounterWiseCollectionPdf: `${services.default}/reports/encounterwisereportsearchpdf`,
  encounterWiseCollectionExcel: `${services.default}/reports/encounterwisereportsearchexcel`,
  paymentTypeWiseReport: `${services.default}/reports/paymenttypewisereportsearch`,
  paymentTypewiseReportPdf: `${services.default}/reports/paymenttypewisereportsearchpdf`,
  paymentTypewiseReportExcel: `${services.default}/reports/paymenttypewisereportsearchexcel`,
  departmentWiseReport: `${services.default}/reports/departmentwisecollectiondetails`,
  departmentwiseReportPdf: `${services.default}/reports/departmentwisecollectiondetailspdf`,
  userwiseReportSearch: `${services.default}/reports/userwisecollectiondetails`,
  userwiseReportSearchpdf: `${services.default}/reports/userwisecollectiondetailspdf`,
  cptgroupwisereportdetails: `${services.default}/reports/cptgroupwisereportdetails`,
  cptgroupwisereportdetailspdf: `${services.default}/reports/cptgroupwisereportdetailspdf`,
  expenseReportSearch: `${services.default}/reports/expensereportsearch`,
  expenseReportSearchpdf: `${services.default}/reports/expensereportpdf`,
  expenseReportSearchexcel: `${services.default}/reports/expensereportexcel`,
  insuranceClaimSummaryReport: `${services.default}/reports/insuranceclaimsummaryreportsearch`,
  insuranceClaimSummaryReportPdf: `${services.default}/reports/insuranceclaimsummaryreportsearchpdf`,
  insuranceClaimSummaryReportExcel: `${services.default}/reports/insuranceclaimsummaryreportsearchexcel`,
  insuranceWiseClaimReport: `${services.default}/reports/insurancewiseclaim`,
  insuranceWiseClaimReportPdf: `${services.default}/reports/insurancewiseclaimpdf`,
  insuranceWiseClaimReportExcel: `${services.default}/reports/insurancewiseclaimexcel`,
  insuranceClaimDetailsReport: `${services.default}/reports/insuranceclaimdetail`,
  insuranceClaimDetailsReportPdf: `${services.default}/reports/insuranceclaimdetailpdf`,
  insuranceClaimDetailsReportExcel: `${services.default}/reports/insuranceclaimdetailexcel`,
  claimTemplateQatar: `${services.default}/reports/claimtemplateqatar`,
  // reconciliation report
  reconsilationReport: `${services.default}/reports/reconsilation`,
  reconsilationReportSearchexcel: `${services.default}/reports/reconsilationexcel`,
  departmentWiseAppointmentListReport: `${services.default}/reports/departmentwiseappointmentlistreportsearch`,
};

const billing = {
  billingList: `${services.default}/billing/getpatientsforbilling`,
  billedDetails: `${services.default}/billing/getbilledpatients`,
  billedItems: `${services.default}/billing/getallbills`,
  billedItemsv2: `${services.default}/billing/getAllBillsByIdinternalcodes`,
  billingCptEdit: `${services.default}/billing/editcpt`,
  billingSave: `${services.default}/billing/saveallbills`,
  billDelete: `${services.default}/billing/deletebills`,
  billPrint: `${services.default}/billing/invoice`,
  billPrintV2: `${services.default}/billing/arabicinvoiceinternalcodes`,
  outHousePrint: `${services.default}/billing/outhouse`,
  //  getIndividualAndGroup
};

const DashboardApi = {
  getDashboardData: `${services.default}/dashboard/`,
};

const RadiologyApi = {
  getRadiologyList: `${services.default}/radiology/findradiosearch`,
  getRadiologyitemList: `${services.default}/radiology/getradiologydetails/`,
  findRadiology: `${services.default}/radiology/findradio`,
  saveRadiology: `${services.default}/radiology/saveradiology`,
  deleteRadiology: `${services.default}/radiology/deleteradiology`,
  getTemplate: `${services.default}/lab/gettemplatefield`,
  saveOrUpdateRadiology: `${services.default}/radiology/saveradiologyresult`,
  getuploadfiles: `${services.default}/uploaddocuments/getradiodetails/`,
  getUploadedFile: `${services.default}/uploaddocuments/getradiodetailFile/`,
  getPrint: `${services.default}/radiology/getradiologyreportpdf/`,
};

const LabApi = {
  getLabSearch: `${services.default}/lab/labsearch`,
  getLabitemList: `${services.default}/lab/getlabdetails/`,
  getTemplates: `${services.default}/lab/gettemplatefield`,
  getLabResult: `${services.default}/lab/findlabresult`,
  getAbnormalFlag: `${services.default}/lab/getallabnormalflags/${clinicId}`,
  saveLabResult: `${services.default}/lab/savelabresult`,
  getLabReportPdf: `${services.default}/lab/labreportpdf`,
  uploadLabResultFile: `${services.default}/uploaddocuments/resultupload`,
  uploadLabResultFileV2: `${services.default}/uploaddocuments/v2/resultupload`,
  getUploadedFiles: `${services.default}/uploaddocuments/getlabdetails/`,
  getUploadedFile: `${services.default}/uploaddocuments/getDocument`,
};

const notification = {
  all: `${services.default}/notification/verification/`,
};

const whatsappApi = {
  sendLabRadiologyReport: `${services.default}/whatsapp/sendlabradiologyreport`,
  sendReviewLink: `${services.default}/whatsapp/sendreviewlink/`,
};

const MastersApi = {
  // ICD masters
  getIcdTableData: `${services.default}/icdmaster/findicd`,
  saveIcdMasterData: `${services.default}/icdmaster/addicd`,
  uploadIcdFile: `${services.default}/icdmaster/resultupload`,
  getIcdUploadedData: `${services.default}/icdmaster/geticduploaddata`,
  importAllIcdData: `${services.default}/icdmaster/icdimportall`,
  clearAllIcdImportedData: `${services.default}/icdmaster/clearimport`,
  // Observation Template
  getAllObservationTemplate: `${services.default}/observationtemplate/findobservationtemplate`,
  updateObservationTemplateStatus: `${services.default}/observationtemplate/updatestatus`,
  observationCpt: `${services.default}/observationtemplate/getcptforobservationtemplate`,
  observationLoincCodes: `${services.default}/observationtemplate/getloinc`,
  observationTemplateFields: `${services.default}/observationtemplate/getobservationstemplate`,
  observationTemplateSave: `${services.default}/observationtemplate/createobservationtemplate`,
  observationLablist: `${services.default}/observationtemplate/getlabbysearch`,
  // General masters
  allClinicians: `${services.default}/encounter/getclinicians`,
  allDoctorsMaster: `${services.default}/doctor/listalldoctor`,
  updateDoctorStatus: `${services.default}/doctor/updatestatusdoc`,
  saveDoctorMaster: `${services.default}/doctor/savedoctor`,
  deleteDoctorMaster: `${services.default}/doctor/deletedoctors`,
  doctorCptDropdown: `${services.default}/doctor/cptdropdown`,
  getDoctorLicense: `${services.default}/doctor/getlicensebydocid`,
  getDoctorsTimeslots: `${services.default}/doctor/timeslot`,
  addDoctorTimeSlot: `${services.default}/doctor/addtimeslot`,
  // insurance Plan Masters
  getInsurancePlanTableData: `${services.default}/InsurancePlan/find`,
  saveInsurancePlanData: `${services.default}/InsurancePlan/save`,
  // insurancePriceMaster
  getNetwork: `${services.default}/insuranceprice/getinsnetworkbyinsdetails`,
  getcptGroups: `${services.default}/insuranceprice/getallcptgroup/`,
  getInsPlan: `${services.default}/insuranceprice/getinsplanbyinsdetails`,
  saveReference: `${services.default}/insuranceprice/savereference`,
  getAllReference: `${services.default}/insuranceprice/getallreference`,
  getCptBygrpId: `${services.default}/doctor/cptdropdown`,
  saveRate: `${services.default}/insuranceprice/saverate`,
  getRateTable: `${services.default}/insuranceprice/getratebysearch`,
  getRateTablev2: `${services.default}/insuranceprice/getratebysearchinternalcodes`,
  priceListUpload: `${services.default}/insuranceprice/uploadfile`,
  // insurance api
  getAllInsurance: `${services.default}/insurancemaster/getinsurancemaster`,
  saveInsuranceMaster: `${services.default}/insurancemaster/saveinsurance`,
  uploadInsuranceExcel: `${services.default}/insurancemaster/readexcel`,
  deleteInsurance: `${services.default}/InsurancePlan/delete`,
  // discount Master
  getAllDiscountInsurance: `${services.default}/discountmaster/getinsurances`,
  AddorEditDiscount: `${services.default}/discountmaster/adddiscount`,
  findDiscount: `${services.default}/discountmaster/find/`,
  deleteDiscount: `${services.default}/discountmaster/delete/`,
  // network Master
  getNetworkMaster: `${services.default}/network/find`,
  SaveNetworkMaster: `${services.default}/network/save`,
  // Rate master api
  getAllRateList: `${services.default}/ratemaster/getuploadeddata`,
  uploadRateDataFile: `${services.default}/ratemaster/uploaddata`,
  updateRateStatus: `${services.default}/ratemaster/updatestatus`,
  deleteRate: `${services.default}/ratemaster/deletepricelistbyid/`,
  updateStatus: `${services.default}/ratemaster/updatestatus`,
  // Appointment type master
  getAllAppointmentTypes: `${services.default}/appointment/find`,
  saveAppointMaster: `${services.default}/appointment/save`,
  // Employee master
  getAllEmployees: `${services.master}/employee/find`,
  saveEmployees: `${services.master}/employee/save`,
  // UOM master
  getAllUOM: `${services.default}/uom/finduom`,
  addUOM: `${services.default}/uom/adduom`,
  updateUOM: `${services.default}/uom/updatestatus`,
  deleteUOM: `${services.default}/uom/deleteuom/`,
  // Country master
  getAllCountries: `${services.default}/country/allcountry`,
  saveCountry: `${services.default}/country/save`,
  deleteCountry: `${services.default}/country/delete/`,
  // State master
  getAllState: `${services.default}/state/allstates`,
  saveState: `${services.default}/state/save`,
  deleteState: `${services.default}/state/delete/`,
  // Purpose master
  getPurpose: `${services.default}/purpose/find`,
  savePurpose: `${services.default}/purpose/save`,
  // Category master
  getAllAccountCategory: `${services.default}/category`,
  saveAccountCategory: `${services.default}/category/save`,
  deleteAccountCategory: `${services.default}/category/delete/`,
  // Account type master
  getAllAccountTag: `${services.default}/accounttag`,
  saveAccountType: `${services.default}/accounttag/save`,
  deleteAccountType: `${services.default}/accounttag/delete/`,
  // Package Master
  findPackage: `${services.default}/package/find`,
  getPackageList: `${services.default}/package/getpackage`,
  getPackageCptList: `${services.default}/package/edit`,
  deletePackageCpt: `${services.default}/package/delete`,
  packageNameSearch: `${services.default}/package/getpackagenamebysearch`,
  packageCptSearch: `${services.default}/package/getcpt`,
  saveORUpdatePackage: `${services.default}/package/save`,
  updatePackageStatus: `${services.default}/package/updatestatus`,
  fetchPackageDetails: `${services.default}/package/getpackagedetail`,
  getPreviousHistory: `${services.default}/emrhistory/fields`,
  getSubDepartments: `${services.default}/package/getsubdepartment`,
  saveSubDepartments: `${services.default}/package/savesubdepartment`,
  //package handling
  setPackage: `${services.default}/packageemr/addpackage`,
  deletePackage: `${services.default}/packageemr/deletepackage`,
  getCategory: `${services.default}/package/getcategory`,
  saveCategory: `${services.default}/package/savecategory`,
  getSpecimen: `${services.default}/package/getspecimen`,

  // clinician Masters
  getAllClinician: `${services.default}/clinicianmaster/findemployee`,
  findEmployee: `${services.default}/clinician/findemployee`,
  saveClinician: `${services.default}/clinicianmaster/saveclinician`,
  uploadClinicanExcel: `${services.default}/clinicianmaster/readexcel`,
  getAllMinistry: `${services.default}/clinic/getallministry`,
  getEmployee: `${services.master}/employee/getemployees`,
  // Companies
  getAllCompanies: `${services.default}/company/find`,
  findCompanys: `${services.default}/company/save`,
  // HPI Masters
  getAllHpiMasters: `${services.default}/hpi/findHpi`,
  hpiSave: `${services.default}/hpi/saveUpdateHpi`,
  getHpiComponents: `${services.default}/hpi/getallhpicomponent`,
  // Blood group Masters
  getAllBloodGroupMasters: `${services.default}/bloodgroupmaster/find`,
  bloodGroupSave: `${services.default}/bloodgroupmaster/addBloodGroup`,
  // Frequency master
  getFrequencyMaster: `${services.default}/frequencyMaster/find`,
  frequencyMasterSave: `${services.default}/frequencyMaster/addNew`,
  // Disease master
  getAllDisease: `${services.default}/diseaseMaster/findDisease`,
  diseaseSave: `${services.default}/diseaseMaster/newDisease`,
  deleteDisease: `${services.default}/diseaseMaster/delete/`,
  // CPT Group master
  getAllCptGroup: `${services.default}/cptgroupmaster/findAll`,
  CptGroupSave: `${services.default}/cptgroupmaster/createnew`,
  // Complaint master
  getAllComplaints: `${services.default}/complaintMaster/findall`,
  complaintsSave: `${services.default}/complaintMaster/savecomplaint`,
  // ROS
  findRos: `${services.default}/ros/find`,
  saveRos: `${services.default}/ros/save`,
  getAllBodySystem: `${services.default}/ros/getallbodysystems`,
  // Drug master
  getAllDrugs: `${services.default}/drugMaster/find`,
  drugSave: `${services.default}/drugMaster/saveDrug`,
  // Denial Code master
  getAllDenialCode: `${services.default}/denial`,
  saveDenialCode: `${services.default}/denial/save`,
  // cpt Master
  getAllCpt: `${services.default}/cptmaster/find`,
  getAllCptv2: `${services.default}/cptmaster/findinternalcodes`,
  saveCpt: `${services.default}/cptmaster/save`,
  saveCptv2: `${services.default}/cptmaster/saveinternalcodes`,
  uploadCpt: `${services.default}/cptmaster/uploadFile`,
  // Loinc Master
  getAllLoinc: `${services.default}/loinc`,
  saveLoinc: `${services.default}/loinc/save`,
  deleteLoinc: `${services.default}/loinc/delete/`,
  // PFSH Template Master
  getPFSHTemplate: `${services.default}/pfshtemplate/getallpfshtemplates`,
  savePFSHTemplate: `${services.default}/pfshtemplate/savepfshtemplate`,
  // Radiology Template Master
  getRadiologyTemplate: `${services.default}/radiologytemplatemaster/findradiology`,
  saveRadiologyTemplate: `${services.default}/radiologytemplatemaster/save`,
  // Lab Template Master
  getLabTemplate: `${services.default}/labtemplatemaster/findlabtemplates`,
  saveLabTemplate: `${services.default}/labtemplatemaster/save`,
  // Speciality master
  getAllSpeciality: `${services.default}/speciality/find`,
  saveSpeciality: `${services.default}/speciality/save`,
  // insurance Type Master
  getAllInsuranceType: `${services.default}/insurancetype/findinstype`,
  saveInsuranceType: `${services.default}/insurancetype/save`,
  deleteInsuranceType: `${services.default}/insurancetype/deleteinsurancetype`,
  // Management Master
  getAllManagement: `${services.default}/managementplan/findmanagement`,
  saveManagement: `${services.default}/managementplan/save`,
  getMnageMentType: `${services.default}/managementplan/getManagementType/`,
};

const SettingsApi = {
  // Post Office
  editPostOffice: `${services.default}/postoffice/save`,
  getPostOffice: `${services.default}/postoffice/getpo/`,
  // User
  saveUser: `${services.master}/users/saveuser`,
  getAllUser: `${services.master}/users/findusers`,
  getAllClicnis: `${services.default}/user/getclinics`,
  getUserGroup: `${services.default}/user/getusergroups/`,
  getEmployees: `${services.master}/employee/getemployees`,
  updateSatus: `${services.master}/users/updatestatus`,
  // userGroup
  getAllUserGroup: `${services.master}/usergroup`,
  SaveUserGroup: `${services.master}/usergroup/save`,
  deleteUserGroup: `${services.master}/usergroup/delete/`,
  // clinic settings
  getClinicTabledata: `${services.master}/clinic/getclinics`,
  getClinicSetings: `${services.master}/users/clinicsettings`,
  updateClinicStatus: `${services.default}/clinic/updatestatus`,
  ministriesForClinic: `${services.default}/clinic/getallministry`,
  saveClinic: `${services.master}/clinic/save`,
  // User privilege
  getUserPrivilageUsers: `${services.master}/users/getallusers/`,
  getUserPrivilageUserTypes: `${services.default}/userprivilege/getallusergroup/`,
  getAllPrivilageList: `${services.master}/v1/privileges/getmaster`,
  savePrivilage: `${services.master}/v1/privileges/savemaster`,
  menuRearrange: `${services.master}/menu/rearrangemenu`,
  // Menu settings
  menuSettingsList: `${services.master}/menu/findmenu`,
  saveMenuSettings: `${services.master}/menu/addmenu`,
  updateMenuSettings: `${services.master}/menu/updatestatus`,
  menuParentList: `${services.default}/menu/getallparent/`,
  // log History
  getLogHistory: `${services.default}/api/loghistory/find`,
  // user Log
  getUserLog: `${services.master}/userlog/find`,
  // backUp
  getAllBackUp: `${services.default}/backup`,
  sqlBackUp: `${services.default}/backup/sqlbackup`,
  // Expense Master
  getAllExpense: `${services.default}/expencemanager/getallexpences`,
  SaveExpense: `${services.default}/expencemanager/save`,
  getAllTag: `${services.default}/expencemanager/getAllTag/`,
  // Google OAuth / Forms
  googleOAuthStatus: `${services.default}/api/google/oauth/status`,
  googleOAuthConnect: `${services.default}/api/google/oauth/connect`,
  googleOAuthDisconnect: `${services.default}/api/google/oauth/disconnect`,
  patientQuestionnaire: `${services.default}/patient-questionnaire`,
};

const patientFeedbackApi = {
  getDetails: `${services.default}/patient-feedback/details`,
  submitFeedback: `${services.default}/feedback/submit`,
  getAllFeedback: `${services.default}/feedback/getall`,
  reviewLink: `${services.default}/feedback/reviewlink/`,
};

const voiceAssistantApi = {
  prompt: `${services.default}/ai/patient-service`,
  fetchClinicWallet: `${services.master}/ai/fetch-clinic-wallet`,
};

const messengerApi = {
  createConversation: `${services.websocket}/messenger/conversations`,
  listConversations: `${services.websocket}/messenger/conversations/user`,
  getConversation: `${services.websocket}/messenger/conversations`,
  sendMessage: `${services.websocket}/conversation/send`,
  messageHistory: `${services.websocket}/conversation`,
  markDelivered: `${services.websocket}/conversation/receipts/delivered`,
  markRead: `${services.websocket}/conversation/receipts/read`,
  wsEndpoint: `${services.websocket}/ws-websocket`,
};

const api = {
  authentication,
  receptionApi,
  patientRegistrationApi,
  insuranceApi,
  tokenString: access_token,
  clinicId,
  patientEncounterApi,
  access_token,
  emr,
  walletapi,
  nursingApi,
  patientBookingApi,
  billing,
  cashierApi,
  reportsApi,
  DashboardApi,
  RadiologyApi,
  LabApi,
  notification,
  whatsappApi,
  MastersApi,
  SettingsApi,
  voiceAssistantApi,
  patientFeedbackApi,
  messengerApi,
};

export default api;
